import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=0a32a140&scoped=true&"
import script from "./ServiceItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceItem.vue?vue&type=style&index=0&id=0a32a140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a32a140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a32a140')) {
      api.createRecord('0a32a140', component.options)
    } else {
      api.reload('0a32a140', component.options)
    }
    module.hot.accept("./ServiceItem.vue?vue&type=template&id=0a32a140&scoped=true&", function () {
      api.rerender('0a32a140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/ServiceItem.vue"
export default component.exports